import { render } from "./SLASection.vue?vue&type=template&id=bc24dea8"
import script from "./SLASection.vue?vue&type=script&setup=true&lang=js"
export * from "./SLASection.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/components/SLASection.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "bc24dea8"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('bc24dea8', __exports__)) {
    api.reload('bc24dea8', __exports__)
  }
  
  module.hot.accept("./SLASection.vue?vue&type=template&id=bc24dea8", () => {
    api.rerender('bc24dea8', render)
  })

}


export default __exports__